import {AxiosInstance, AxiosPromise, AxiosRequestConfig} from 'axios'
import { OrderItemsResponse, OrderRequestParams } from '/@src/models/api'
import gql from 'graphql-tag'

export function getOrderList(
  api: AxiosInstance,
  params: OrderRequestParams
): Promise<OrderItemsResponse> {
  const data: AxiosRequestConfig = {
    params: {
      order_no:params.orderId,
      user_id:params.userId,
      size: params.limit,
      anchor: params.cursor,
      sort_type: params.sort,
      order_state: 'COMPLETE',
      source: params.platform,
      pay_channel: params.payChannel,
      time_start: params.timeStart,
      time_end: params.timeEnd,
    },
  }
  return api.get('/v1/admin/orders', data)
}

export const remarkOrder = (api: AxiosInstance,orderId:string,text:string): AxiosPromise=>{
  return api.post('/v1/admin/order/remark',{
    order_id:orderId,
    remark:text
  })
}

/*
* 获取新订单接口
* */
export const NewOrdersDocument = gql`
query SearchOrders(
    $order_no: String
    $pagination: PaginationInput
    $orderStatus: OrderStatus
    $userId: Int
  ) {
    orders(
      order_no: $order_no
      pagination: $pagination
      order_status: $orderStatus
      user_id: $userId
    ) {
      nodes {
        order_no
        platform
        real_pay_amount
        id
        user_info {
          user_id
        }
        order_items {
          sku_detail {
            name
          }
        }
        created_at
        transactions {
          pay_time
          pay_channel
        }
      }
      total_count
    }
  }
`
